import { Form, Modal } from 'antd';
import ScheduleFormList from './ScheduleFormList';

interface ScheduleBulkCreateModalProps {
  visible: boolean;
  gongjongList?: any;
  onCreate: (data: any) => void;
  onCancel: () => void;
}

function ScheduleBulkCreateModal({
  visible,
  gongjongList,
  onCreate,
  onCancel,
}: ScheduleBulkCreateModalProps) {
  const [form] = Form.useForm();

  const searchSubScheduleList = async (formData: any) => {};

  return (
    <>
      <Modal
        open={visible}
        title="공정 생성"
        okText="확인"
        cancelText="취소"
        width={700}
        onCancel={onCancel}
        onOk={() => {
          form
            .validateFields()
            .then((values) => {
              onCreate(values);
            })
            .catch((info) => {
              console.error('Validate Failed:', info);
            });
        }}
      >
        <Form
          form={form}
          onFinish={searchSubScheduleList}
          initialValues={gongjongList}
        >
          <ScheduleFormList />
        </Form>
      </Modal>
    </>
  );

  /*
  return (
    <>
      <Modal
        open={visible}
        title="공정 생성"
        okText="확인"
        cancelText="취소"
        width={800}
        onCancel={onCancel}
        onOk={() => {
          form
            .validateFields()
            .then((values) => {
              console.log(values);
              onCreate(values);
            })
            .catch((info) => {
              console.error('Validate Failed:', info);
            });
        }}
      >
        <Form
          form={form}
          onFinish={searchSubScheduleList}
          initialValues={gongjongList}
        >
          <Form.List name="nameList">
            {(fields, { add, remove, move }) => (
              <>
                {fields.map(({ key, name, ...restField }, index) => (
                  <Row justify={'center'}>
                    <Col span={8}>
                      <Space
                        key={key}
                        style={{
                          display: 'flex',
                        }}
                        align="baseline"
                      >
                        <Form.Item
                          {...restField}
                          name={[name, 'name']}
                          rules={[
                            { required: true, message: '공정명을 입력하세요' },
                          ]}
                          key={key}
                        >
                          <Input
                            placeholder="예) 철거공사"
                            style={{ width: '200px' }}
                          />
                        </Form.Item>
                        <MinusCircleOutlined
                          onClick={() => {
                            remove(name);
                          }}
                          rev={undefined}
                        />
                        <ArrowUpOutlined
                          onClick={() => move(index, index - 1)}
                          disabled={index === 0}
                          rev={undefined}
                        />
                        <ArrowDownOutlined
                          onClick={() => move(index, index + 1)}
                          disabled={index === fields.length - 1}
                          rev={undefined}
                        />
                      </Space>
                    </Col>
                  </Row>
                ))}
                <Form.Item>
                  <Row justify={'center'}>
                    <Col span={8}>
                      <Button
                        type="dashed"
                        onClick={() => add()}
                        block
                        icon={<PlusOutlined rev={undefined} />}
                      >
                        추가
                      </Button>
                    </Col>
                  </Row>
                </Form.Item>
              </>
            )}
          </Form.List>
        </Form>
      </Modal>
    </>
  );
  */
}

export default ScheduleBulkCreateModal;
